import { Routes } from '@angular/router';

export const legalRoutes: Routes = [
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./terms/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./privacy/privacy.component').then((m) => m.PrivacyComponent),
  },
];
